// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"5c3eb3d7","105":"5c3eb3d7","2855":"5c3eb3d7","4105":"1f08cf17"}[chunkId] + ".chunk.css";
};